import { Component, Input, OnInit } from '@angular/core';
import { thread } from './thread.types';

@Component({
  selector: 'am-thread',
  templateUrl: './thread.component.html',
  styleUrls: ['./thread.component.scss'],
})
export class ThreadComponent implements OnInit {
  @Input() thread: thread;
  @Input() depth = 0;
  depthStyle: { [klass: string]: any };

  ngOnInit() {
    // iterate color set fade
    // this.depthStyle = {
    //   'border-color': `var(--marine-rv-${(this.depth % 4) + 1})`,
    // };
    // mono fade
    // this.depthStyle = { opacity: 1 - ((this.depth % 4) * 3) / 10 };
  }
}
